import React, { useEffect, useState } from 'react';
import JobCard from '../components/JobCard';
import AccessibilityBar from '../components/AccessibilityBar';
import { API_BASE_URL } from '../config/apiConfig';
import './PageStyles.css'; // Optional shared styling

const BankingJobs = () => {
  const [bankingJobs, setBankingJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFallback, setShowFallback] = useState(false);
  const [fallbackJobs, setFallbackJobs] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/jobs?limit=1000`)
      .then(response => response.json())
      .then(data => {
        const allJobs = data.jobs || [];
        const filtered = allJobs.filter(job => 
          job.jobType === 'Banking' 
        );

        if (filtered.length > 0) {
          setBankingJobs(filtered);
        } else {
          setShowFallback(true);
          setFallbackJobs(allJobs);
        }

        setLoading(false);
      })
      .catch(() => {
        setBankingJobs([]);
        setFallbackJobs([]);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <AccessibilityBar />
      <div className="container">
        <h1>🏦 Banking Jobs</h1>

        {loading ? (
          <p>Loading jobs...</p>
        ) : showFallback ? (
          <>
            <p>No Banking jobs found. Showing all available jobs instead:</p>
            <div className="grid">
              {fallbackJobs.map(job => (
                <JobCard key={job._id} job={job} />
              ))}
            </div>
          </>
        ) : (
          <div className="grid">
            {bankingJobs.map(job => (
              <JobCard key={job._id} job={job} />
            ))}
          </div>
        )}
      </div>
      
    </>
  );
};
export default BankingJobs;